import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="sticky-footer border-top border-light-gray gray h6">
      <div className="sm-col px2">
        &copy; {currentYear} Saptak Sen. All rights reserved.
      </div>
      <div className="sm-col-right px2">
        <a 
          href="https://saptak.in" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="gray hint--top"
          data-hint="Saptak's Website"
        >
          <i className="fa fa-fw fa-lg fa-home"></i>
        </a>
        <a 
          href="https://github.com/saptak/saptak_photos" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="gray hint--top ml2"
          data-hint="GitHub"
        >
          <i className="fa fa-fw fa-lg fa-github-square"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;